
import moment from "moment";

export function dateTime(date){
    moment.locale('th');
    return moment(date).format('MMMM Do YYYY, h:mm:ss a');
}
